"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (g && (g = 0, op[0] && (_ = 0)), _) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initExponea = exports.initSnowplow = exports.hasCookieForSession = exports.isLocalEnv = exports.getCountryPlatform = exports.getBrowsingApp = void 0;

var browser_tracker_1 = require("@snowplow/browser-tracker");

var js_cookie_1 = __importDefault(require("js-cookie"));

var domain_1 = require("@raisin/cp-utils/lib/utils/domain");

var feature_flag_react_client_1 = require("@raisin/feature-flag-react-client");

var constants_1 = require("./constants");

var initClient = function initClient() {
  return __awaiter(void 0, void 0, void 0, function () {
    var clientSideId, user, options;
    return __generator(this, function (_a) {
      clientSideId = constants_1.LAUNCH_DARKLY_CLIENT_SIDE_IDS[(0, domain_1.getEnvironment)()] || constants_1.LAUNCH_DARKLY_CLIENT_SIDE_IDS.development;
      user = new feature_flag_react_client_1.FeatureFlagUserBuilder().investorRegion((0, domain_1.getRegionFromHost)()).build();
      options = {
        streaming: true
      };
      return [2, (0, feature_flag_react_client_1.featureFlagClientInit)(clientSideId, user, options)];
    });
  });
};

var getFeatureFlagClient = function getFeatureFlagClient() {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2, initClient().then(function (client) {
        if (client) {
          return client;
        }

        return console.warn('Initializing LaunchDarkly client incorrectly. LD client value:', client);
      }).catch(function (err) {
        return console.warn('Failed iniatizing LaunchDarkly client.', err);
      })];
    });
  });
};

var isCSR = function isCSR() {
  return typeof window !== 'undefined';
};

var detectMobileBrowser = function detectMobileBrowser() {
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone/i.test(navigator.userAgent)) {
    return 'web-mobile';
  } else {
    return 'web';
  }
};

var getBrowsingApp = function getBrowsingApp() {
  return js_cookie_1.default.get(constants_1.COOKIE_FOR_MOBILE_NAME) ? 'app-webview' : detectMobileBrowser();
};

exports.getBrowsingApp = getBrowsingApp;

var getCountryPlatform = function getCountryPlatform() {
  return window.location.hostname.replace('www.', '');
};

exports.getCountryPlatform = getCountryPlatform;
exports.isLocalEnv = constants_1.LOCAL_ENVS.some(function (env) {
  return isCSR() && env.test(window.location.host);
});

var hasCookieForSession = function hasCookieForSession() {
  var cookie = js_cookie_1.default.get(constants_1.COOKIE_FOR_SESSION_NAME);
  return !!cookie && cookie === 'true';
};

exports.hasCookieForSession = hasCookieForSession;

var initSnowplow = function initSnowplow(defaultAppId) {
  var _a;

  var snowplowAppId = js_cookie_1.default.get(constants_1.COOKIE_FOR_MOBILE_NAME) === 'true' ? 'mobile_app' : constants_1.SNOWPLOW.APP_IDS[window.location.hostname];
  var appId = defaultAppId || snowplowAppId;
  (0, browser_tracker_1.newTracker)(constants_1.SNOWPLOW.TRACKER_ID, exports.isLocalEnv ? constants_1.SNOWPLOW.TEST_ENDPOINT : constants_1.SNOWPLOW.PROD_ENDPOINT, {
    appId: appId
  });
  var snowplowUnsentEvent = (_a = window === null || window === void 0 ? void 0 : window.localStorage) === null || _a === void 0 ? void 0 : _a.getItem("snowplowOutQueue_".concat(constants_1.SNOWPLOW.TRACKER_ID, "_post2"));

  if (snowplowUnsentEvent && JSON.parse(snowplowUnsentEvent).length > 0) {
    (0, browser_tracker_1.trackSelfDescribingEvent)({
      event: {
        schema: constants_1.SNOWPLOW.SCHEMA,
        data: {}
      }
    });
  }
};

exports.initSnowplow = initSnowplow;

var initExponea = function initExponea(locale) {
  getFeatureFlagClient().then(function (client) {
    var _a, _b;

    var exponeaToken;
    var scriptType;
    var flags = client.allFlags();

    if (flags.b2cExponeaSDKProjectKeys) {
      if (constants_1.GB_LOCALES.includes(locale)) {
        exponeaToken = exports.isLocalEnv ? constants_1.EXPONEA.TEST_TOKEN.GB : constants_1.EXPONEA.PROD_TOKEN.GB;
      } else {
        exponeaToken = exports.isLocalEnv ? constants_1.EXPONEA.TEST_TOKEN.EU : constants_1.EXPONEA.PROD_TOKEN.EU;
      }
    } else {
      if (constants_1.DE_LOCALES.includes(locale)) {
        exponeaToken = exports.isLocalEnv ? constants_1.EXPONEA_OLD.TEST_TOKEN.DE_AT : constants_1.EXPONEA_OLD.PROD_TOKEN.DE_AT;
      } else {
        exponeaToken = exports.isLocalEnv ? constants_1.EXPONEA_OLD.TEST_TOKEN.EU_GB : constants_1.EXPONEA_OLD.PROD_TOKEN.EU_GB;
      }
    }

    var exponeaConsentStatus = (_b = (_a = window === null || window === void 0 ? void 0 : window['UC_UI']) === null || _a === void 0 ? void 0 : _a.getServicesBaseInfo()) === null || _b === void 0 ? void 0 : _b.find(function (data) {
      return data.name === 'Exponea';
    }).consent.status;
    exponeaConsentStatus ? scriptType = 'text/javascript' : scriptType = 'text/plain';
    var exponeaSnippet = document.createElement('script');
    exponeaSnippet.setAttribute('type', scriptType);
    exponeaSnippet.setAttribute('data-usercentrics', 'Exponea');
    exponeaSnippet.text = "!(function (e, n, t, i, o, r) {\n          var a = 4e3,\n            c = 'xnpe_async_hide';\n          function s(e) {\n            return e.reduce(\n              function (e, n) {\n                return (\n                  (e[n] = function () {\n                    e._.push([n.toString(), arguments]);\n                  }),\n                  e\n                );\n              },\n              { _: [] },\n            );\n          }\n          function m(e, n, t) {\n            var i = t.createElement(n);\n            i.src = e;\n            var o = t.getElementsByTagName(n)[0];\n            return o.parentNode.insertBefore(i, o), i;\n          }\n          (r.target = r.target || 'https://api.exponea.com'),\n            (r.file_path = r.file_path || r.target + '/js/exponea.min.js'),\n            (e[t] = s([\n              'anonymize',\n              'initialize',\n              'identify',\n              'update',\n              'track',\n              'trackLink',\n              'trackEnhancedEcommerce',\n              'getHtml',\n              'showHtml',\n              'showBanner',\n              'showWebLayer',\n              'ping',\n              'getAbTest',\n              'loadDependency',\n              'getRecommendation',\n              'reloadWebLayers',\n            ])),\n            (e[t].notifications = s(['isAvailable', 'isSubscribed', 'subscribe', 'unsubscribe'])),\n            (e[t].snippetVersion = 'v2.1.0'),\n            (function (e, n, t) {\n              (e[n]['_' + t] = {}),\n                (e[n]['_' + t].nowFn = e[t] && e[t].now ? e[t].now.bind(e[t]) : Date.now),\n                (e[n]['_' + t].snippetStartTime = e[n]['_' + t].nowFn());\n            })(e, t, 'performance'),\n            (function (e, n, t, i, o, r) {\n              e[o] = {\n                sdk: e[i],\n                sdkObjectName: i,\n                skipExperiments: !!t.new_experiments,\n                sign: t.token + '/' + (r.exec(n.cookie) || ['', 'new'])[1],\n                path: t.target,\n              };\n            })(e, n, r, t, o, RegExp('__exponea_etc__' + '=([\\w-]+)')),\n            (function (e, n, t) {\n              m(e.file_path, n, t);\n            })(r, i, n),\n            (function (e, n, t, i, o, r, s) {\n              if (e.new_experiments) {\n                !0 === e.new_experiments && (e.new_experiments = {});\n                var p = e.new_experiments.hide_class || c,\n                  u = e.new_experiments.timeout || a,\n                  _ = encodeURIComponent(r.location.href.split('#')[0]),\n                  l =\n                    e.target +\n                    '/webxp/' +\n                    n +\n                    '/' +\n                    r[t].sign +\n                    '/modifications.min.js?http-referer=' +\n                    _ +\n                    '&timeout=' +\n                    u +\n                    'ms';\n                'sync' === e.new_experiments.mode &&\n                r.localStorage.getItem('__exponea__sync_modifications__')\n                  ? (function (e, n, t, i, o) {\n                      (t[o][n] = '<' + n + ' src=\"' + e + '\"></' + n + '>'),\n                        i.writeln(t[o][n]),\n                        i.writeln(\n                          '<' +\n                            n +\n                            '>!' +\n                            o +\n                            '.init && document.writeln(' +\n                            o +\n                            '.' +\n                            n +\n                            '.replace(\"/' +\n                            n +\n                            '/\", \"/' +\n                            n +\n                            '-async/\").replace(\"><\", \" async><\"))</' +\n                            n +\n                            '>',\n                        );\n                    })(l, n, r, s, t)\n                  : (function (e, n, t, i, o, r, a, c) {\n                      r.documentElement.classList.add(e);\n                      var s = m(t, i, r);\n                      function p() {\n                        o[c].init || m(t.replace('/' + i + '/', '/' + i + '-async/'), i, r);\n                      }\n                      function u() {\n                        r.documentElement.classList.remove(e);\n                      }\n                      (s.onload = p), (s.onerror = p), o.setTimeout(u, n), (o[a]._revealPage = u);\n                    })(p, u, l, n, r, s, o, t);\n              }\n            })(r, i, o, 0, t, e, n),\n            (function (e, n, t) {\n              e[n].start = function (i) {\n                i &&\n                  Object.keys(i).forEach(function (e) {\n                    return (t[e] = i[e]);\n                  }),\n                  e[n].initialize(t);\n              };\n            })(e, t, r);\n        })(window, document, 'exponea', 'script', 'webxpClient', {\n          target: 'https://raisin-api.exponea.com',\n          token: '".concat(exponeaToken, "',\n          track: {\n            visits: true,\n          },\n          spa_reloading: {\n            on_hash_change: false,\n            on_url_change: true,\n            visits: true,\n          },\n        });\n        exponea.start();");
    document.getElementsByTagName('head')[0].appendChild(exponeaSnippet);
  });
};

exports.initExponea = initExponea;